import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import type { CountryType } from "@sellar-io/common";
import { InputRoot } from "./InputRoot";
import { generatePlaceholder } from "./utils/generatePlaceholder";

export const InputPostalCode = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement> & { country?: CountryType },
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const { country, ...inputProps } = props;

    return (
      <InputRoot
        ref={ref}
        {...inputProps}
        type="text"
        pattern={
          country === "GB"
            ? "[A-Za-z]{1,2}\\d[A-Za-z\\d]?\\s*\\d[A-Za-z]{2}"
            : inputProps.pattern
        }
        title={
          country
            ? country === "GB"
              ? "Valid GB postcode"
              : "Postal code"
            : inputProps.title
        }
        autoComplete="postal-code"
        className={twMerge("w-full", inputProps.className)}
        placeholder={generatePlaceholder(inputProps.placeholder)}
      />
    );
  },
);

InputPostalCode.displayName = "InputPostalCode";
